import { styled } from '@mui/system'
import { Box } from '@mui/material'
import { MuiButton } from '../../../components'

export const CollapseContent = styled(Box)(`
  display:flex;
  flex-direction:column;
  align-items:center;
  border-radius: 4px;
  border: 1px solid #095BBD;
  padding: 16px 0;
  max-height: calc(100vh - 210px);
  position: relative;
  
  & .CollapseRightIconWrapper {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & .slick-slider {
    padding: 15px 0;

    .slick-slide {
      border-bottom : none;
      border-top: none;
    }

    & .slick-prev , .slick-next {
        display : flex !important;
        bottom: -15px;
        width: 100%;
        justify-content: center;
        left: 0;
        right: 0;
     
        svg circle {
          r : 0
        }
      
    }

    & .slick-prev:hover , .slick-next:hover {
      background : #F2F8FF;

      svg {
        path {
          stroke : #095BBD;
          }
        } 
    }

    & .slick-prev:active , .slick-next:active {
      background : #E4EEFB;

      circle {
        r : 0
      }
      
      svg {
        path {
          stroke : #063D7E;
          }
        } 
    }

    & .slick-prev {
      top : 0;
      margin: -5px 0;
    }

    & .slick-next {
      top : auto;
      margin: -10px 0;
    }

    & .slick-prev:before { content: '';}
    & .slick-next:before { content: '';}
  
    & .slick-prev svg path { stroke :#242424;  }
    & .slick-disabled svg path { stroke : #ADADAC;  }
  }
`)

export const TableChipCompleted = styled(Box)(`
  font-weight: 600;
  font-size: 14px;
  margin-right: 5px;
  color: #008767;
`)

export const TableChipAdminReview = styled(Box)(`
  font-weight: 600;
  font-size: 14px;
  margin-right: 5px;
  color: #429F8A;
`)

export const TableChipInProgress = styled(Box)(`
  font-weight: 600;
  font-size: 14px;
  margin-right: 5px;
  color: #C88F16;
  cursor:pointer;
`)

export const InnerWrapper = styled(Box)(
  (props) => `
  color: ${props?.type?.toLowerCase() === 'completed' ? '#000' : '#7E7E7E'};
  display: flex !important;
  align-items: center;
  width: 100%;
  gap: 8px;
  border-bottom: 1px #E7E7E6 solid;
  // border-radius: 4px;

  & .row {
    width: 100%;
    min-height: 36px;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-decoration: none;
    font-size: 14px;
    font-weight: 400; // 300;
    color: #000;
    padding : 6px 16px;
  }
  & .row:hover {
    background: #F2F8FF;

    p {
      color : #095BBD;
    }
  }
`
)

export const PhaseWrapper = styled('p')(`
  // font-size: 14px;
  // font-weight: 400; // 300;
  // width: 100%;
`)

export const ChipsWrapper = styled(Box)(`
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`)

export const ArrowWrapper = styled(Box)(`
  width: 25px;
`)

export const RhsOuterWrapper = styled(Box)(`
  position: sticky;
  top:10px;
  right:20px;
  display: flex;
  flex-direction: column;
  width: 40%;
  min-width:460px;
  height: 100%;
`)

export const RhsWrapper = styled(Box)(`
  width: 100%;
`)

export const TopSection = styled(Box)(`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 76px;
  position: relative;
  min-height: 76px;
  padding-top: 4px;

  .imageIcon {
    position: absolute; top: 0; left: 0;
  }
`)

export const TopSectionHeading1 = styled(Box)(`
  font-size: 22px;
  font-weight: 400;
`)

export const TopSectionHeading2 = styled(Box)(`
  font-size: 16px;
  font-weight: 400;
`)

export const ImageIconWrapper = styled(Box)(`
  width: 32px;
  height: 32px;
  border: 1px solid  #D8D8D6;
  border-radius: 50%;
  background: #F6F6F5;
  display: flex;
  justify-content: center;
  align-items: center;
  
  &.large {
    width: 64px;
    height: 64px;
  }
  
  &:before{
    content: attr(data-content);
      display: none;
      width: 2ch; /* 2 characters */
      overflow: hidden;
      white-space: nowrap;
      text-transform: uppercase;
  }
  &:empty:before{
      display: block;
  }
`)
